import React from 'react';
import ReactDOM from 'react-dom/client';
import { TelegramRouter } from 'telegram-router';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <TelegramRouter>
      <App />
    </TelegramRouter>
  </React.StrictMode>
);